// extracted by mini-css-extract-plugin
module.exports = {"button":"dh-dh-klima-spesial-english-button--ed9b0c772c700c695af302a6cd55cd89","buttonActive":"dh-dh-klima-spesial-english-buttonActive--008b3b2ae355f59e8af96cb183571837"};